import { Modal } from 'modules/modals'
import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useEffect,
  useState,
} from 'react'
import { EBookStatus } from './types'

type BookProps = {
  children: ReactNode
}

type BookContextProps = {
  isOpen: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>
  status: EBookStatus
  setStatus: Dispatch<SetStateAction<EBookStatus>>
}

export const BookContext = createContext<BookContextProps>({
  isOpen: false,
  setIsOpen: () => {
    throw new Error('setIsOpen called outside of BookProvider')
  },
  status: EBookStatus.book,
  setStatus: () => {
    throw new Error('setStatus called outside of BookProvider')
  },
})

export const BookProvider = ({ children }: BookProps) => {
  const initialIsOpen =
    new URLSearchParams(window.location.search).get('modal') === 'reservation'
  const [isOpen, setIsOpen] = useState(initialIsOpen)
  const [status, setStatus] = useState<EBookStatus>(EBookStatus.book)

  const value = {
    isOpen,
    setIsOpen,
    status,
    setStatus,
  }

  useEffect(() => {
    const url = new URL(window.location.href)
    const currentParam = url.searchParams.get('modal')

    if (isOpen && currentParam !== 'reservation') {
      url.searchParams.set('modal', 'reservation')
      window.history.pushState({}, '', url)
    } else if (!isOpen && currentParam) {
      url.searchParams.delete('modal')
      window.history.pushState({}, '', url)
    }
  }, [isOpen])

  useEffect(() => {
    setStatus(EBookStatus.book)
  }, [isOpen])

  return (
    <>
      <BookContext.Provider value={value}>
        {children}
        {isOpen && <Modal.Book />}
      </BookContext.Provider>
    </>
  )
}
